import React, { useEffect, useState } from 'react';
import InternalContainer from '../../layout/containers/Internal';
import { BackButton, Box, Loader } from '../../../common/components';
import SchemeSanctionsForm from '../components/SchemeSanctionForm/SchemeSanctionForm';
import { actions } from '../redux/ProductReducer';
import { connect } from 'react-redux';

const InsurerSchemesSanctionContainer = ({
  onGetSchemes,
  onUpdate,
  params: { insurerCode },
}) => {
  const [schemes, setSchemes] = useState([]);
  const [noSchemesFound, setNoSchemesFound] = useState(false);

  useEffect(() => {
    Promise.resolve(onGetSchemes('active,pending,test', insurerCode, [])).then(
      (schemes) => {
        if (!schemes || !schemes.length) {
          setNoSchemesFound(true);
        } else {
          setSchemes(schemes);
        }
      },
    );
  }, []);

  const updateSchemes = (values) => {
    return Promise.resolve(onUpdate(values)).then(() => {
      return onGetSchemes('active,pending,test', insurerCode, []);
    });
  };

  if (noSchemesFound) {
    return (
      <InternalContainer title={'Sanctions'}>
        <Box>
          <h2>{`No active schemes found`}</h2>
        </Box>
      </InternalContainer>
    );
  }

  if (!schemes.length) {
    return (
      <InternalContainer title={'Sanctions'}>
        <Loader />
      </InternalContainer>
    );
  }

  return (
    <InternalContainer title={'Sanctions'} buttons={<BackButton />}>
      <Box>
        <SchemeSanctionsForm schemes={schemes} onUpdate={updateSchemes} />
      </Box>
    </InternalContainer>
  );
};

export default connect(
  null,
  {
    onGetSchemes: actions.getInsurerSchemesByStatus,
    onUpdate: actions.updateSanctions,
  },
)(InsurerSchemesSanctionContainer);
